export const utilityColors = {
  utilityBackground: '#F1F1F1',
  utilityInformationBackground: '#F1F1F1',
  utilityText: '#000000',
  utilityWhite: '#FFF',
} as const;
